import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ComponentsModule } from '../../../components/components.module';
import { PipesModule } from '../../../pipes/pipes.module';
import { LearnLessonInfoComponent } from './learn-lesson-info.component';

@NgModule({
  imports: [
    AngularCore,
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule,
    LearnLessonInfoComponent
  ],
  exports: [
    LearnLessonInfoComponent
  ]
})
export class LearnLessonInfoModule {
}

export {
  LearnLessonInfoComponent
};

